
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/canal-etic/canal-etic-marato",
      function () {
        return require("private-next-pages/corporatiu/canal-etic/canal-etic-marato/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/canal-etic/canal-etic-marato"])
      });
    }
  